export default "__VITE_ASSET__B37Mlije__"